var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cjIndex",attrs:{"direction":"vertical"}},[_c('el-container',[_c('el-header',[_c('el-row',{style:({marginTop:'1vh'})},[_vm._v("大人来也抽签摇号系统")])],1),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }